import LangAdmin from './zh-cn/admin';
import LangBilling from './zh-cn/billing';
import LangCompany from './zh-cn/company';
import LangComponent from './zh-cn/component';
import LangDocument from './zh-cn/document';
import LangDownloadCenter from './zh-cn/download-center';
import LangErrCodeMsg from './zh-cn/err-msg';
import LangGameContent from './zh-cn/game-content';
import LangHomeNav from './zh-cn/home-nav';
import LangInvoice from './zh-cn/invoice';
import LangMessageCenter from './zh-cn/message-center';
import NoticeInvoice from './zh-cn/notice';
import LangOther from './zh-cn/other';
import LangPrice from './zh-cn/price';
import LangRbac from './zh-cn/rbac';
import LangStudio from './zh-cn/studio';
import LangUser from './zh-cn/user';

// // 中文配置
const common = {
  common_header_home: '首页',
  owner_email: '所有者 (邮箱账户)',
  created_time: '创建时间 (UTC)',
  create_time: '创建时间 (UTC)',
  create_time_local: '创建时间',
  creator_email: '创建者 (邮箱账户)',
  code_name: '游戏代号',
  last_modify_time: '最后一次修改时间 (UTC)',
  last_modify_time_local: '最后一次修改',
  modify_time: '修改时间 (UTC)',
  modify_time_local: '修改时间',
  update_time: '更新时间 (UTC)',
  update_time_local: '更新时间',
  list: '列表',
  new: '新建',
  operate: '操作',
  view: '查看',
  edit: '编辑',
  create: '创建',
  delete: '删除',
  submit: '提交',
  cancel: '取消',
  confirm: '确认',
  confirm_to: '前往',
  close: '关闭',
  open: '打开',
  refresh: '刷新',
  opened: '已开启',
  closed: '已关闭',
  remove: '移除',
  save: '保存',
  yes: '是',
  no: '否',
  dev_type: 'DEV',
  live_type: 'LIVE',
  contact_us: '联系我们',
  clear_all: '清除筛选',
  all: '所有消息',
  owner_type: '所有者',
  admin_type: '管理员',
  id: '编号',
  sort: '编序',
  env: '环境',
  region: '主站',
  create_by: '创建者',
  status: '状态',
  game: '游戏',
  title: '游戏名称',
  // name_lowercase:'name',
  name_uppercase: '名称',
  member_name: '成员名称',
  environment: '环境',
  environments: '环境',
  password: '密码',
  email_uppercase: '邮箱账户',
  email_lowercase: '邮箱',
  please_enter: '请输入',
  please_enter_field: '请输入{{name}}',
  please_enter_email: '请输入邮箱账号',
  please_enter_password: '请输入密码',
  common_status_step_pending: '处理中',
  common_status_step_approved: '已通过',
  common_status_step_rejected: '已驳回',
  common_status_step_active: '启用中',
  common_status_step_expired: '到期',
  common_status_step_partly: '部分可见',
  common_disable: '停用',
  common_enable: '启用',
  successfully: '成功',
  success: '成功',
  save_success: '保存成功',
  save_failed: '保存失败',
  failed: '失败',
  failed_submit: '提交失败',
  select_items: '选中{{count}}个条目，',
  total_items: '总计{{total}}个条目',
  total_with_checked_items: '总计 {{total}} 个条目, 已选择 {{count}} 条',
  can_not_empty: '不可为空',
  i_know: '了解',
  sorry_404_desc: '对不起, 您浏览的页面不存在',
  back: '返回',
  select_all_tag: '全部',
  site_switch_cn: '站点切换',
  site_switch_en: '站点切换',
  site_switch_woa: '站点切换',
  site_switch_pre: '站点切换',
  site_switch_cn_desc: '您即将前往InGame中国站，是否继续？',
  site_switch_en_desc: '您即将前往InGame国际站，是否继续？',
  site_switch_woa_desc: '您即将前往InGame内网环境，是否继续？',
  site_switch_pre_desc: '您即将前往InGame预发布环境，是否继续？',
  ...LangStudio,
  ...LangAdmin,
  ...LangComponent,
  ...LangDocument,
  ...LangGameContent,
  ...LangUser,
  ...LangErrCodeMsg,
  ...LangMessageCenter,
  ...LangOther,
  ...LangDownloadCenter,
  ...LangHomeNav,
  ...LangPrice,
  ...LangRbac,
  ...LangBilling,
  ...LangCompany,
  ...LangInvoice,
  ...NoticeInvoice,
};
// eslint-disable-next-line no-restricted-syntax
export default Object.assign(common);
